import { styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';
import { Skeleton } from '@app-velocity/ui';
import { useGetTeamsQuery } from '@app-velocity/libs/teams-data-access';

import { useOrgUsageContext } from '../../context/useOrgUsageContext';

const Teams = styled('ul')(({ theme }) => ({
  listStyleType: 'none',
  margin: 0,
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
}));

const Team = styled('li')(({ theme }) => ({
  background: 'var(--input-input-background-color)',
  borderRadius: theme.spacing(1),
  padding: theme.spacing(4),
  display: 'flex',

  fontSize: 14,
  fontWeight: 500,
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
}));

export const ByTeam = () => {
  const { t } = useI18n();
  const { simStatsByTeam } = useOrgUsageContext();
  const { data: members, isLoading: areTeamsLoading } = useGetTeamsQuery();

  if (areTeamsLoading) return <Skeleton height={50} />;

  if (!simStatsByTeam) return null;

  const { teamSimulations } = simStatsByTeam;

  if (!teamSimulations) return null;

  return (
    <Teams>
      {members?.map((team) => (
        <Team key={team.teamId}>
          <span>{team.teamName}</span>
          <span>
            {t('teams:usage.simulations.n_sims', {
              count: teamSimulations[team.teamId!] || 0,
            })}
          </span>
        </Team>
      ))}
    </Teams>
  );
};
